import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.jsx';
import AppHeader from '../components/layout/AppHeader.jsx';

export default function Dashboard() {
  const { user, roles, permissions } = useAuth();

  return (
    <div className="app-shell">
      <AppHeader />

      <main className="app-main">
        <div className="card">
          <h1>Welcome, {user?.name || 'there'}</h1>
          <p className="muted">
            You're signed in to the BOS+ platform foundation. ERP, PM, QA, CRM and Collaboration
            modules will plug into this shell.
          </p>
          <p>
            <Link to="/hr" className="btn primary">Open HR module →</Link>
            {' '}
            <Link to="/finance" className="btn secondary">Open Finance module →</Link>
          </p>

          <h3>Your roles</h3>
          <ul className="chips">
            {roles.length === 0 && <li className="muted">No roles assigned</li>}
            {roles.map((r) => (
              <li key={r} className="chip">{r}</li>
            ))}
          </ul>

          <h3>Permissions ({permissions.length})</h3>
          <ul className="permissions">
            {permissions.map((p) => (
              <li key={`${p.resource}:${p.action}`}>
                <code>{p.resource}:{p.action}</code>
              </li>
            ))}
          </ul>
        </div>
      </main>
    </div>
  );
}
